import { createElement, FunctionComponent } from "react";
import { Route } from "react-router";
import { RouteProps } from "react-router-dom";
import { RouteDescription } from "../types";

export const filterRealRoutes = (routes?: RouteDescription[]): RouteDescription[] => routes?.map?.(x => ({
  ...x,
  children: filterRealRoutes(x.children) as any,
}))
  .flatMap(x => x.path ? [ x ] : x.children) || [];

export const plainRoutes = (routes?: RouteDescription[]): RouteDescription[] => routes?.flatMap(x => [ x, ...plainRoutes(x.children || []) ]) || [];

export const renderRoute = (routes: RouteDescription[] | undefined, permissionCheckerComponent: FunctionComponent<{
  route: RouteDescription
}>): any => routes?.map?.(route => {
  const somePermissionsRequired = (
    route.requiredPermissions?.length ||
    route.requiredOneOfPermissions?.length ||
    Object.values(route.pageModePermissions || {})
      .flatMap(x => [
        ...(Array.isArray(x.requiredPermissions) ? x.requiredPermissions : [ x.requiredPermissions ]),
        ...(Array.isArray(x.requiredOneOfPermissions) ? x.requiredOneOfPermissions : [ x.requiredOneOfPermissions ]),
      ])
      .filter(x => x)
      .length
  );

  return createElement(Route, {
    ...route as RouteProps,
    element: somePermissionsRequired ? createElement(permissionCheckerComponent, { route }) : route.element,
    key: route.path ?? "/",
    children: renderRoute(route.children, permissionCheckerComponent),
  });
}) || null;
